import Main from './ActivitiesPanelMain'
import ActivityEdit from './ActivityEdit'
import ActivityShow from './ActivityShow'
import NotificationSettings from './NotificationSettings'

export default { Main, ActivityEdit, ActivityShow, NotificationSettings }
